module.exports = __webpack_public_path__ + "img/cashier-ad-04.57deb77d.png";